<template>
  <div
    id="home"
    class="flex flex-col-reverse lg:flex-row-reverse lg:h-screen h-2/3 lg:max-w-7xl mx-auto justify-center items-center"
  >
    <div
      class="hidden lg:flex justify-center items-center self-center mx-8 my-3"
    >
      <img class="h-4/6 p-36 pt-10" src="../assets/cover.png" />
    </div>
    <div class="flex flex-col h-max py-44 lg:py-4">
      <h1 class="block self-center lg:self-start w-max xl:text-9xl text-8xl font-extrabold px-16 -mt-2">
        <span class="sunset">evala</span>
      </h1>
      <p
        class="block text-center self-center lg:self-start lg:text-left text-xl font-normal w-4/5 text-gray-500 my-8 mx-16"
      >
        <strong class="text-black font-medium">Your pocket guide.</strong> 
        Makes sure you visited everything you wanted and more.
      </p>
      <a
        href="#access"
        class="rounded-full px-8 py-3 mx-20 mt-4 text-xl font-medium shadow-sm text-black bg-gray-100 hover:bg-orange-600 hover:text-white xl:self-start self-center"
      >
        Get Access
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="mx-2 h-5 w-5 inline-block"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M14 5l7 7m0 0l-7 7m7-7H3"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  methods: {
    routeToNewsletter() {
      this.$router.push('#access')
    }
  }
};
</script>

<style lang="scss">
.sunset {
  background: linear-gradient(
    -45deg,
    #811d41,
    #983275,
    #fd2f24,
    #ff6f01,
    #fed800
  );
  background-size: 300%;
  letter-spacing: -5px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: animated_text 10s ease-in-out infinite;
  -moz-animation: animated_text 10s ease-in-out infinite;
  -webkit-animation: animated_text 10s ease-in-out infinite;
}

@keyframes animated_text {
  0% {
    background-position: 0px 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0px 50%;
  }
}
</style>
